import React from "react";
import { Link } from "react-router-dom";
const Nav = () => {
    return (
        <section className='container-fluid p-0 header fixed-top'>
            <div className='row '>
                <div className='col-12'>
                    <nav className="navbar navbar-expand-lg ">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#"></a>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-auto">
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Home'>Home</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/About'>About</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Service'>Service</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Cars'>Cars</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Gallary'>Gallary</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Shop'>Shop</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Pages'>Pages</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" to='/Contact'>Contact</Link>
                                    </li>
                                </ul>
                                <form className="d-flex" role="search">
                                    <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                                    <button className="btn btn-outline-white text-white" type="submit">Search</button>
                                </form>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </section>
    );
};

export default Nav;